import _ from "~/helpers/utils";

/**
 * DebugSizes component displays the current screen size in a fixed position
 * at the bottom left of the screen. It is only visible in development mode.
 * The sizes are displayed based on Tailwind's responsive breakpoints.
 */
export default function DebugSizes() {

  if (!_.isDev()) {
    return null;
  }

  return <div
    className="fixed bottom-1 left-1 size-10 bg-black text-2xl leading-0 text-white rounded-full flex items-center justify-center z-[2001]"
  >
    <div className="flex flex-col gap-2 items-center *:hidden">
      <div className="max-sm:inline">&lt;sm</div>
      <div className="sm:max-md:inline">sm</div>
      <div className="md:max-lg:inline">md</div>
      <div className="lg:max-xl:inline">lg</div>
      <div className="xl:max-2xl:inline">xl</div>
      <div className="2xl:inline">2xl</div>
    </div>
  </div>

}